import {Component, Vue} from 'nuxt-property-decorator'
import {Context, NuxtError} from '@nuxt/types'
import {Severity} from '@sentry/types'
import {Page} from '../types/Pages'
import handlerAddSourceInCopyText from '@pp-frontend/shared-packages/utils/add-source-in-copy-text'

@Component({})
export default class AliasPage extends Vue {
  articles!: Page[]
  article!: Page

  async asyncData(context: Context) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    try {
      // @ts-ignore
      const article: Page = await context.$static.getPage(context.params.alias).then((data) => {
        const article: Page = Object.assign({}, data)

        const h2 = article.content.match(/<h2>(.*?)<\/h2>/g)
        // @ts-ignore
        for (let x = 0; x < h2?.length; x++) {
          article.content = article.content.replace(/<h2>/, '<h2 id="' + x + '">')
        }

        return Object.freeze(article)
      }) as Page
      // @ts-ignore
      const articles = await context.$static.getPageList(article.category_id as any).then((data) => {
        const articles: Page[] = data

        const startIndex = articles.findIndex(item => item.alias === article.alias) + 1
        const result = articles.slice(startIndex)
        result.push(...articles.slice(0, startIndex))

        return Object.freeze(result.slice(0, process.env.APP_ID === 'oplata_fssp_web_app' ? 4 : 6))
      })

      return {
        article,
        articles
      }
    } catch (err) {
      context.$sentry.captureMessage('Ошибка при получении статики', Severity.Warning)
      return context.error(err as NuxtError)
    }
  }

  mounted() {
    (document.querySelector('#article') as HTMLElement).addEventListener('copy', this.addSourceInCopyText)
    document.querySelectorAll('.ogl').forEach((item, index) => {
      item.addEventListener('click', () => {
        const h2s = document.querySelectorAll('h2, h3, h4, h5')
        window.scrollTo({
          top: h2s[index].getBoundingClientRect().top + window.scrollY - 100,
          behavior: 'smooth'
        })
      })
    })
    if (this.$route.query.email) {
      this.$axios.patch(process.env.API_ENDPOINT + 'user', {email: this.$route.query.email})
    }

    /** добавляем ленивую загрузку для iframe, которым это нужно */
    const container = document.getElementById('article')
    const iframes = container?.querySelectorAll('iframe[data-lazy]') || []

    Array.prototype.forEach.call(iframes, (el) => {
      this.$lazyLoad(el)
    })
  }

  beforeDestory() {
    const articleEl = (document.querySelector('#article') as HTMLElement)
    if (articleEl) {
      articleEl.removeEventListener('copy', this.addSourceInCopyText)
    }
  }

  addSourceInCopyText(evt) {
    handlerAddSourceInCopyText(evt, this.$route.path)
  }
}
